// === ./src/frontend/components/StatsFloatingCard.jsx ===
import React from "react";
import { Box, Typography, alpha, useTheme } from "@mui/material";
import { float } from "./animations";

const StatsFloatingCard = ({ icon: Icon, label, value, color, delay = 0 }) => {
  const theme = useTheme();
  const isDark = theme.palette.mode === "dark";

  return (
    <Box
      sx={{
        px: 2,
        py: 1.25,
        borderRadius: 2.5,
        bgcolor: isDark ? alpha(theme.palette.background.paper, 0.9) : "#fff",
        border: `1px solid ${alpha(color, 0.2)}`,
        boxShadow: `0 8px 24px ${alpha(color, 0.15)}`,
        display: "flex",
        alignItems: "center",
        gap: 1.25,
        animation: `${float} ${3.5 + delay}s ease-in-out infinite`,
        animationDelay: `${delay}s`,
      }}
    >
      <Box
        sx={{
          width: 32,
          height: 32,
          borderRadius: 1.5,
          bgcolor: alpha(color, 0.12),
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <Icon sx={{ fontSize: 16, color }} />
      </Box>
      <Box>
        <Typography
          variant="caption"
          color="text.secondary"
          sx={{ fontSize: "0.6rem", display: "block" }}
        >
          {label}
        </Typography>
        <Typography
          variant="caption"
          fontWeight={800}
          color="text.primary"
          sx={{ fontSize: "0.78rem" }}
        >
          {value}
        </Typography>
      </Box>
    </Box>
  );
};

export default StatsFloatingCard;
